import styled from 'styled-components';

export const MaxWidthContainer = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.maxWidth.container};
  margin: 0 auto;
`;
